import API from "@utils/plugins/API";

const GearEUService = {
  all: (params) => {
    return API.get("gear-eu", { params: params });
  },
  create: (name, name_eng, description) => {
    return API.post("gear-eu", {
      name,
      name_eng,
      description,
    });
  },
  update: (id, name, name_eng, description) => {
    return API.put(`gear-eu/${id}`, {
      name,
      name_eng,
      description,
    });
  },
  find: (id) => {
    return API.get(`gear-eu/${id}`);
  },
  destroy: (id) => {
    return API.delete(`gear-eu/${id}`);
  },
};

export default GearEUService;
